/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Portals_Readiness_LoadingInputs */

const cs_portals_readiness_loading = /** @type {(inputs: Portals_Readiness_LoadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Načítám matici…`)
};

const en_portals_readiness_loading = /** @type {(inputs: Portals_Readiness_LoadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Loading matrix…`)
};

/**
* | output |
* | --- |
* | "Loading matrix…" |
*
* @param {Portals_Readiness_LoadingInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const portals_readiness_loading = /** @type {((inputs?: Portals_Readiness_LoadingInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Portals_Readiness_LoadingInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_portals_readiness_loading(inputs)
	return cs_portals_readiness_loading(inputs)
});